export const EXTRATO_CONTA_REQUEST = 'EXTRATO_CONTA_REQUEST';
export const EXTRATO_CONTA_SUCCESS = 'EXTRATO_CONTA_SUCCESS';
export const LIMPA_EXTRATO = 'LIMPA_EXTRATO';
